import {getAccount} from '@/rest/payments/get-account';
import {store} from '@/redux-store/store';
import {setStripeAccountVerification} from '@/redux-store/slices/auth';
import {isAccountVerified} from '.';

export const checkVerification = async () => {
  try {
    const info = await getAccount();
    if (info) {
      const {isVerified, missingRequirements} = isAccountVerified(info);
      store.dispatch(
        setStripeAccountVerification({
          isVerified,
          requirements: missingRequirements
        })
      );
      return isVerified;
    } else {
      return false;
    }
  } catch (error) {
    console.error('Error in checkVerification', error);
    return false;
  }
};
